import React from "react";

const DynamicMenu = (props) => {
  const { isOpen } = props;
  return (
    <div className="relative z-10 w-full md:w-1/2 xl:w-full">
      <div
        className={`pl-51.5px bg-white w-full max-w-md mx-auto transition-transform ${
          isOpen ? "transform translate-y-0" : "transform -translate-y-full"
        }`}>
        <div className="px-6 ml-19.5px">
          <ul>
            <li>
              <a
                href="#"
                className="text-light-gray text-lg hover:text-blue-700 block font-bold py-5">
                Agent
              </a>
            </li>
            <li>
              <a
                href="#"
                className="text-light-gray text-lg hover:text-blue-700 block font-bold py-5">
                Balance
              </a>
            </li>
            <li>
              <a
                href="#"
                className="text-light-gray text-lg hover:text-blue-700 block font-bold py-5">
                Transaction
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default DynamicMenu;
